'use strict';
{
    var app = angular.module('tf.optnChain', [])
        .controller('optnChainCtrl', ['$scope', '$state', function adviserController($scope, $state) {


            scope.gridOptions = {
                flatEntityAccess : true,
                enableVerticalScrollbar : uiGridConstants.scrollbars.ALWAYS,
                enableHorizontalScrollbar : uiGridConstants.scrollbars.NEVER,
                enableSorting: false,
                enableColumnMenus : false,
                onRegisterApi: function(gridApi){
                    scope.gridApi = gridApi;
                    gridUtil.disableAnimations(gridApi.grid.element);
                    gridApi.core.on.rowsRendered(scope, maybeScrollToSelectedOption);
                },

                //rowTemplate : "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>",
                excessRows : 100,
                minRowsToShow : 9,
                columnDefs : [
                    {name: 'call.option.code',  type : 'string', displayName : 'Code', width: '*',
                        cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)">{{row.entity.call.option.code}}</div>'},
                    {name: 'call.price.p',  type : 'number', displayName : 'Theo Price', width: '*', cellFilter : 'number : 3',
                        cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)">{{row.entity.call.price.p | number : 3}}</div>'},
                    {name: 'call.price.v',  type : 'number', displayName : 'Volatility', width: '*', cellFilter: 'percentage : 2',
                        cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)">{{row.entity.call ? (row.entity.call.price.v | percentage : 2) : \'\'}}</div>'},
                    {name: 'call.price.d',  type : 'number', displayName : 'Delta', width: '*' , cellFilter : 'number : 3',
                        cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)">{{row.entity.call.price.d | number : 3}}</div>'},
                    // {name: 'call.oi.interest',  type : 'number', displayName : 'o/n Interest', width: '*' , cellFilter : 'number : 0',
                    //     cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)">{{row.entity.call.oi | number : 0}}</div>'},
                    {name: 'level',  type : 'number', displayName : 'Strike', width: '*', headerCellClass : 'strike', cellClass : 'strike',
                        cellTemplate: '<div class="ui-grid-cell-contents strike">{{row.entity.level | strike : grid.appScope.chain.code === \'XJO\'}}</div>'
                    },
                    {name: 'put.option.code',  type : 'string', displayName : 'Code', width: '*',
                        cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)">{{row.entity.put.option.code}}</div>'},
                    {name: 'put.price.p',  type : 'number', displayName : 'Theo Price', width: '*', cellFilter : 'number : 3',
                        cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)">{{row.entity.put.price.p | number : 3}}</div>'},
                    {name: 'put.price.v',  type : 'number', displayName : 'Volatility', width: '*', cellFilter: 'percentage : 2',
                        cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)">{{row.entity.put ? (row.entity.put.price.v | percentage : 2) : \'\'}}</div>'},
                    {name: 'put.price.d',  type : 'number', displayName : 'Delta', width: '*' , cellFilter : 'number : 3',
                        cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)">{{row.entity.put.price.d | number : 3}}</div>'}
                    // {name: 'put.oi.interest',  type : 'number', displayName : 'o/n Interest', width: '*' , cellFilter : 'number : 0',
                    //     cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)">{{row.entity.put.oi | number : 0}}</div>'}

                ],
                data :  []
            };


            return function (underlying) {
                return $http.get('/tradefloor/api/options/' + underlying.toUpperCase()).then(function (chainResponse){
                    return processChain(chainResponse.data);
                });

                function processChain(chainData) {
                    var sortedSeries = Object.keys(chainData).sort();
                    var previousSeries = null;

                    var chain = {
                        code : underlying,
                        series : [],
                        codes : {}
                    };

                    for (var i = 0; i <  sortedSeries.length; i++) {
                        var expiryName = sortedSeries[i];
                        var expiry = new Date(expiryName);
                        var series = chainData[expiryName];

                        series.expiry = expiry;
                        series.previousSeries = previousSeries;
                        series.nextSeries = null;

                        if (previousSeries != null) {
                            previousSeries.nextSeries = series;
                        }
                        previousSeries = series;


                        var ladder = [];

                        series.ladder = [];

                        series.closestRung = function closestRung(price) {
                            var closest = null;

                            for (var i = 0; i < this.ladder.length; i++) {
                                var rung = this.ladder[i];

                                if (closest == null) {
                                    closest = rung;
                                    continue;
                                }

                                var closestDistance = Math.abs(price - closest.level);
                                var currentDistance = Math.abs(price - rung.level);

                                if (currentDistance < closestDistance) {
                                    closest = rung;
                                }
                            }

                            return closest;
                        };

                        for (var j = 0; j < series.length; j += 4) {
                            var code = series[j];
                            var type = series[j + 1];
                            var style = series[j + 2];
                            var strike = series[j + 3];

                            var option = {
                                code: code,
                                security: chain,
                                expiry: expiry,
                                strike: strike,
                                style: style == 'A' ? 'AMERICAN' : 'EUROPEAN',
                                type: type == 'P' ? 'PUT' : 'CALL',
                                series: series
                            };

                            chain.codes[code] = option;

                            var rung = ladder[option.strike];
                            if (rung == null) {
                                rung = {
                                    level: option.strike,
                                    put: null,
                                    call: null
                                };
                                ladder[option.strike] = rung;
                            }
                            option.rung = rung;


                            if (option.type == 'PUT') {
                                rung.put = option;
                            } else if (option.type == 'CALL') {
                                rung.call = option;
                            }
                        }

                        var sortedRungs = Object.keys(ladder).sort(function (a, b) {
                            var aNum = +a;
                            var bNum = +b;

                            if (aNum < bNum)
                                return -1;
                            if (aNum > bNum)
                                return 1;

                            return 0;
                        });

                        var previousRung = null;
                        for (var j = 0; j < sortedRungs.length; j++) {
                            var rung = ladder[sortedRungs[j]];
                            rung.previousRung = previousRung;

                            if (previousRung != null) {
                                previousRung.nextRung = rung;
                            }
                            previousRung = rung;
                            series.ladder.push(rung);
                        }
                        chain.series.push(series);

                    }

                    return chain;
                }
            };

        }])

}

